var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDianpingSales = function SvgDianpingSales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dianpingSales_svg__a",
    d: "M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dianpingSales_svg__b",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dianpingSales_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4DBEBD",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.778 9.778a1.778 1.778 0 1 1-3.556 0 1.778 1.778 0 0 1 3.556 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.333c.49 0 .889.398.889.89v2.666a.889.889 0 1 1-1.778 0V6.222c0-.49.398-.889.889-.889"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dianpingSales_svg__a",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 3.556,
    mask: "url(#dianpingSales_svg__b)"
  })))));
};
export default SvgDianpingSales;